import React, { useEffect, useState } from "react";
import TopBorder from "../../../reusable/topBorder/TopBorder";
import { useParams } from "react-router-dom";
import OrderDetails from "./OrderDetails";
import CancelOrder from "./CancelOrder";
import DeliverAddress from "./DeliverAddress";
import { user_order_details } from "../../../api/user/order";
import { useDispatch, useSelector } from "react-redux";
import order, { oderdetailLoading } from "../../../reducers/users/order";
import Wrapper from "../../../website/layout/index";
import { isDisabled } from "../../../reducers/common";
import { orderStatus } from "../../../assets/constants/constant";

const UserOrderDetails = () => {
  const dispatch = useDispatch();
  const param = useParams();
  const [orderDetail, setOrderDetail] = useState();
  const { orderDetails } = useSelector((state) => state.order);
  const oderdetailLoading1 = useSelector(
    (state) => state.order.oderdetailLoading
  );

  const res = orderDetails?.statusCode;
  const data = orderDetails?.data;
  const url = window.location.pathname;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (res === 200) {
      setOrderDetail(data);
    }
  }, [orderDetails]);
  useEffect(() => {
    return setOrderDetail();
  }, []);
  useEffect(() => {
    const apiData = {
      orderId: param?.id,
    };
    if (param?.id) dispatch(oderdetailLoading(true));
    dispatch(user_order_details(apiData))
      .then((res) => {
        if (res.statusCode === 200) {
          dispatch(oderdetailLoading(false));
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, [param?.id]);

  useEffect(() => {
    dispatch(isDisabled(true));
  }, []);

  let width = url.includes("admin") ? "70vw" : "";
  return (
    <div className="row">
      <Wrapper
        loading={oderdetailLoading1}
        show={url.includes("admin") ? false : true}
      >
        <TopBorder value={"Order Details"} />
        <div className="section-center my-3" style={{ width: width }}>
          <OrderDetails
            cart={orderDetail?.itemsList}
            orderDetail={orderDetail}
          />
          {/* <OptionalDetails /> */}
          <div className="mt-4">
            <h6>Shipping Address :</h6>
            <DeliverAddress hide={true} item={{}} orderDetail={orderDetail} />
          </div>
          {orderDetail?.orderStatus === orderStatus?.pending &&
            !url.includes("admin") && <CancelOrder orderDetail={orderDetail} />}
          {orderDetail?.orderStatus === orderStatus?.cancelled && (
            <div className="mb-5">
              <h6>Reason for Cancellation :</h6>
              <span style={{ textTransform: "capitalize" }}>
                {orderDetail?.cancelOrderReason}
              </span>
            </div>
          )}
        </div>
      </Wrapper>
    </div>
  );
};

export default UserOrderDetails;
